import {takeEvery} from 'redux-saga/effects';
import {notify} from 'helpers';

export function* notifications() {
  yield takeEvery(action => action.notification, function* ({ notification }) {
    notify(notification);
  });

  yield takeEvery(action => action.errorMessage, function* ({ errorMessage }) {
    notify(errorMessage, { className: 'is-error' });
  });
  // yield takeEvery('*', function* (action) {
  //   if (action.tooltip && action.tooltip.anchor) {
  //     const tooltip = {
  //       close: () => popups.close(tooltip),
  //       Content: action.tooltip.Tooltip,
  //       id: action.tooltip.anchor,
  //       props: { isTootlip: true, hasCloseIcon: true },
  //       anchor: { current: document.querySelector(action.tooltip.anchor) },
  //     }
  //     popups.open(tooltip);
  //   }
  // });
}
